(function ($) {
	'use strict';

	$(function () {
		const activeClass = 'is-active';
		const offcanvasActiveClass = 'site-offcanvas--is-active';

		const $item = $('.js-offcanvas-menu-item');
		const $trigger = $('.js-offcanvas-menu-trigger');
		const $submenu = $('.js-offcanvas-menu-submenu');
		const $back = $('.js-site-offcanvas-back');
		const $backText = $('.js-site-offcanvas-back-text');
		const $offcanvas = $('.js-site-offcanvas');

		$back.removeClass(activeClass);

		$trigger.on('click', function (event) {
			event.preventDefault();

			const title = $(this).closest($item).find($trigger).first().text().trim();

			$(this).parent().find($submenu).first().toggleClass(activeClass).slideToggle();

			$back.toggleClass(activeClass);
			$backText.text(title);
		});

		$back.on('click', function () {
			$submenu.filter(`.${activeClass}`).last().removeClass(activeClass);

			if ($submenu.filter(`.${activeClass}`).length === 0) {
				$back.removeClass(activeClass);
			}
		});

		$($submenu).find('a').not($trigger).on('click', function () {
			$offcanvas.removeClass(offcanvasActiveClass);
		});

		$submenu.each(function () {
			const submenu = $(this);
			const $submenuLinks = $('a', $(this));

			$submenuLinks.first().on('keydown', function (e) {
				if (e.shiftKey && e.key === 'Tab') {
					e.preventDefault();

					$(this).parents('.js-offcanvas-menu-submenu').last().removeClass(activeClass);

					if ($submenu.filter(`.${activeClass}`).length === 0) {
						$back.removeClass(activeClass);
					}

					$(this).parents('.js-offcanvas-menu-submenu').last().prev().focus();
				}
			});

			$submenuLinks.last().on('keydown', function (e) {
				if (!e.shiftKey && e.key === 'Tab') {
					e.preventDefault();

					$(this).parents('.js-offcanvas-menu-submenu').last().removeClass(activeClass);

					if ($submenu.filter(`.${activeClass}`).length === 0) {
						$back.removeClass(activeClass);
					}

					$(this).parents('.js-offcanvas-menu-submenu').last().prev().focus();
				}
			});
		});
	});
})(jQuery);
